module.exports = __webpack_public_path__ + "images/preview_large@2x.png?dc7655ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview_large@2x.png
// module id = 687
// module chunks = 7